import React, { useContext } from "react";
import Moment from "react-moment";
import { Twemoji } from "react-emoji-render";

import { Grid, Typography } from "@material-ui/core";
import { SectionSubtitle, List, ListItem } from "..";

import { Context as ViewsContext } from "../../../context/ViewsContext";
import useStyles from "./styles";

const UserSubscriptions = ({ data, title }) => {
  const { message, link } = useStyles();
  const { setView } = useContext(ViewsContext);

  return (
    <Grid container direction="column">
      <SectionSubtitle text={title} />
      <List>
        {data.length > 0 ? (
          data.map((e, i) => (
            <ListItem
              key={i}
              withLink={`/campaigns/${e.campaign.id}`}
              image={e.campaign.image}
              title={e.campaign.title}
              value={
                <Typography component="span">
                  suscrito hace{" "}
                  <Moment fromNow ago>
                    {e.subscription_date}
                  </Moment>
                </Typography>
              }
            />
          ))
        ) : (
          <Typography className={message}>
            <Twemoji svg text="😧" />
            <br></br> Parece que no estás suscrito a ninguna campaña.
            <br></br>
            <span className={link} onClick={() => setView(0)}>
              Ver campañas
            </span>
          </Typography>
        )}
      </List>
    </Grid>
  );
};

export default UserSubscriptions;
